import styled from '@emotion/styled';
import { Typography } from '@mui/material';

import { useUniversalToFDI } from '@/utils/internationalization/useUniversalToFDI';

import type { MouthAreaWithIsAddressed } from '../patientStrip/patientStripOdontogram/hooks';
import type { TDisplayOrderQuadrantAbbreviations } from '../patientStrip/patientStripOdontogram/types';
import { GridOrderQuadrantAbbreviations } from '../patientStrip/patientStripOdontogram/types';

const StyledDiv = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 0.25em;
  .MuiTypography-root {
    font-size: 1em;
    font-weight: 600;
  }
`;

interface Props {
  affectedAreas: MouthAreaWithIsAddressed[];
}

export const QuadrantsGrid = ({ affectedAreas }: Props) => {
  const { displayLocalizedQuadrantShortName } = useUniversalToFDI();
  if (!affectedAreas.length) return null;

  return (
    <StyledDiv>
      {GridOrderQuadrantAbbreviations.map((quadrant) => {
        const affectedArea = affectedAreas.find(
          ({ mouthArea }) => mouthArea === quadrant,
        );
        const isAffected = !!affectedArea;
        const isAddressed = !!affectedArea?.isAddressed;
        if (!isAffected) return <span key={quadrant}></span>;
        return (
          <Typography
            key={quadrant}
          >{`${displayLocalizedQuadrantShortName(quadrant as TDisplayOrderQuadrantAbbreviations)}${isAddressed ? ' *' : ''}`}</Typography>
        );
      })}
    </StyledDiv>
  );
};
